export default __webpack_public_path__ + "static/media/3031 utensils top.324abc09.png";